/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoders, formatters and utilities for everyday coding.`)
};

const es_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificadores, formateadores y utilidades para programar cada día.`)
};

const de_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoder, Formatierer und Hilfsmittel für den täglichen Code-Alltag.`)
};

const nl_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoders, opmaakhulpmiddelen en hulpprogramma's voor dagelijks programmeren.`)
};

const fr_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodeurs, formateurs et utilitaires pour le codage au quotidien.`)
};

const it_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatori, formattatori e utilità per la programmazione quotidiana.`)
};

const pt_br2_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificadores, formatadores e utilitários para o dia a dia de programação.`)
};

const pt_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificadores, formatadores e utilitários para a programação do dia a dia.`)
};

const ja_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常のコーディングに役立つエンコーダー、フォーマッター、ユーティリティ。`)
};

const zh_cat_developer_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于日常编码的编码器、格式化工具与实用程序。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_developer_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_developer_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_developer_desc", locale)
	if (locale === "en") return en_cat_developer_desc(inputs)
	if (locale === "es") return es_cat_developer_desc(inputs)
	if (locale === "de") return de_cat_developer_desc(inputs)
	if (locale === "nl") return nl_cat_developer_desc(inputs)
	if (locale === "fr") return fr_cat_developer_desc(inputs)
	if (locale === "it") return it_cat_developer_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_developer_desc(inputs)
	if (locale === "pt") return pt_cat_developer_desc(inputs)
	if (locale === "ja") return ja_cat_developer_desc(inputs)
	return zh_cat_developer_desc(inputs)
};